import ReelController from "../../../Elements/Reel/ReelController";

class MainReelController extends ReelController {}

export default MainReelController;
